import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9db88470"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reviews-link-button" }
const _hoisted_2 = {
  key: 0,
  class: "before-click"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["data-url"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "after-click"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = ["data-url"]
const _hoisted_9 = ["src"]

import { onMounted, ref } from 'vue'
import { ReceiveText } from '@/entities/conversation'
import Typography from '@/components/Rain/Typography/Typography.vue'
import ReviewCopyIcon from '@/assets/img/Icons/White/review-copy.svg'
import ReviewGoIcon from '@/assets/img/Icons/White/review-go.svg'
import ReviewGreenCheck from '@/assets/img/Icons/Green/review-check.svg'
import ReviewGreenExclamation from '@/assets/img/Icons/Green/review-exclamation.svg'
import { copyToClipboard } from '@/utils/function'
import { trackReviewLinkClicked } from '@/api/conversation'

interface Props {
    item: ReceiveText
    comment: string
    slug: string
}
const defaultTitle =
    'Use the button below to copy your testimonial and take you to the Reviews page.'
const defaultBtnTitle = 'Copy Testimonial'

export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewLinkButton',
  props: {
    item: {},
    comment: {},
    slug: {}
  },
  emits: ['load'],
  setup(__props: any, { emit: __emit }) {

// customer face survey form component
const props = __props
ref(ReviewCopyIcon)
ref(ReviewGoIcon)

const showGoReviewButton = ref(false)
const countdownSeconds = ref(3)
const shortlinkSlug = ref('')

const requestTitle = ref(props.item.title || defaultTitle)
const btnTitle = ref(props.item.btnTitle || defaultBtnTitle)

const emit = __emit

onMounted(async () => {
    // As this ReviewLinkButton has no input, we need to trigger another next()
    // to mark response finished!!!!
    emit('load')
    const { data } = await trackReviewLinkClicked(
        props.slug,
        props.item.link,
        false
    )
    shortlinkSlug.value = data.linkSlug
})

const copyComment = (link: string | undefined) => {
    copyToClipboard(props.comment)
    showGoReviewButton.value = true

    const timer = setInterval(function () {
        if (countdownSeconds.value <= 1) {
            clearInterval(timer)
            visitReviewPage(link)
        }
        countdownSeconds.value--
    }, 1000)
}

const visitReviewPage = (link: string | undefined) => {
    window.open(link, '_blank')
    trackReviewLinkClicked(props.slug, link, true, shortlinkSlug.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "slide-down" }, {
      default: _withCtx(() => [
        (!showGoReviewButton.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", { src: _unref(ReviewGreenExclamation) }, null, 8, _hoisted_3),
              _createVNode(Typography, { variant: "body1" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(requestTitle.value), 1)
                ], undefined, true),
                _: 1
              }),
              _createElementVNode("button", {
                class: "review-button",
                "data-url": _ctx.item.link,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (copyComment(_ctx.item.link)))
              }, [
                _createElementVNode("img", { src: _unref(ReviewCopyIcon) }, null, 8, _hoisted_5),
                _createVNode(Typography, { variant: "body2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(btnTitle.value), 1)
                  ], undefined, true),
                  _: 1
                })
              ], 8, _hoisted_4)
            ]))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-down" }, {
      default: _withCtx(() => [
        (showGoReviewButton.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("img", { src: _unref(ReviewGreenCheck) }, null, 8, _hoisted_7),
              _createVNode(Typography, { variant: "body1" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Testimonial has been copied. You will be taken to the Reviews page in " + _toDisplayString(countdownSeconds.value) + " seconds. ", 1)
                ], undefined, true),
                _: 1
              }),
              _createElementVNode("button", {
                class: "review-button",
                "data-url": _ctx.item.link,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (visitReviewPage(_ctx.item.link)))
              }, [
                _createElementVNode("img", { src: _unref(ReviewGoIcon) }, null, 8, _hoisted_9),
                _createVNode(Typography, { variant: "body2" }, {
                  default: _withCtx(() => [
                    _createTextVNode("GO NOW")
                  ], undefined, true),
                  _: 1
                })
              ], 8, _hoisted_8)
            ]))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    })
  ]))
}
}

})